module.exports = __webpack_public_path__ + "static/media/lead-generation-image.e1ebc878.png";